import { Text, Button, HStack, VStack } from '@genial/components';
import { Color, Spacing, Typography } from '@genial/design-tokens';
import { useBreakpointValue } from '@genial/utils';
import React from 'react';

import { useRedeemDetailsContext } from '../../contexts/redeem-details';
import { useRedeemRowsContext } from '../../contexts/redeem-rows';
import { useRedeemSummaryContext } from '../../contexts/redeem-summary';

interface FooterProps {}

export const Footer: React.FC<FooterProps> = () => {
  const isMobile = useBreakpointValue({ base: true, sm: false });
  const { handleSendRedeemOffers, handleCancelRedeemOffers, redeemOffersStatus } =
    useRedeemDetailsContext();
  const { redeemRowsDetailsRecords, isLoadingRedeemRowsSummary } = useRedeemSummaryContext();
  const { isLoadingRedeemRows, redeemRowsData } = useRedeemRowsContext();

  if (redeemOffersStatus === 'sent') {
    return null;
  }

  if (isMobile) {
    return (
      <HStack
        borderTopColor={Color['neutral.lightest']}
        borderTopWidth="1px"
        p={Spacing['inset.xs']}
        bg="white">
        <Button
          onPress={handleSendRedeemOffers}
          w="full"
          isDisabled={isLoadingRedeemRows || redeemRowsData.length === 0}
          _text={{ fontWeight: Typography['fontweight.semibold'] }}
          variant="callToAction">
          Enviar
        </Button>
      </HStack>
    );
  }

  return (
    <HStack
      borderTopColor={Color['neutral.lightest']}
      borderTopWidth="1px"
      p={Spacing['inset.xs']}
      bg="white"
      alignItems="center"
      justifyContent="space-between">
      <VStack space={Spacing['stack.quarck']}>
        <Text color="neutral.medium" fontSize={Typography['fontsize.xs']} variant="semibold">
          Adicionados com sucesso
        </Text>
        <Text
          color="neutral.darkest"
          fontSize={Typography['fontsize.xs']}
          isLoading={isLoadingRedeemRowsSummary}>
          {redeemRowsDetailsRecords?.valid} registros
        </Text>
      </VStack>
      <HStack alignItems="center" justifyContent="center" space={Spacing['stack.xxxs']}>
        <Button
          _text={{ fontWeight: Typography['fontweight.semibold'] }}
          variant="secondary"
          onPress={handleCancelRedeemOffers}
          isDisabled={isLoadingRedeemRows}>
          Cancelar
        </Button>
        <Button
          _text={{ fontWeight: Typography['fontweight.semibold'] }}
          onPress={handleSendRedeemOffers}
          variant="callToAction"
          isDisabled={isLoadingRedeemRows || redeemRowsData.length === 0}>
          Enviar
        </Button>
      </HStack>
    </HStack>
  );
};
